module.exports = __webpack_public_path__ + "img/5th-Wheel-Mobile.24ad3bf2.jpg";